import { z } from 'zod';
import { CalendarEventSchema } from '@axiom/validation';

export const InterviewAvailabilityShareableFormSchema = z.object({
  CALENDAR_COMPONENT: CalendarEventSchema.array(),
  TIMEZONE_DROPDOWN: z.string().uuid(),
});

export type InterviewAvailabilityShareableForm = z.infer<
  typeof InterviewAvailabilityShareableFormSchema
>;
